import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AlertaCheddService } from './alerta-chedd.service';
import { SolicitudViewModel } from 'src/app/components/_importacion/solicitudes/datosbasicos/datosbasicos.types';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-alerta-chedd',
    templateUrl: './alerta-chedd.component.html',
    styleUrls: ['./alerta-chedd.component.scss'],
})
export class AlertaCheddComponent implements OnChanges {
    @Input() solicitud: SolicitudViewModel;
    envioCorreoFrChedD = false;

    constructor(
        private alertaChedDService: AlertaCheddService,
        public datepipe: DatePipe,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.solicitud?.currentValue) {
            this.checkCorreoFrChedD(this.solicitud);
        }
    }

    private checkCorreoFrChedD(solicitud: SolicitudViewModel): void {
        if (!solicitud?.FechaEnvio) {
            return;
        }
        const yearEnvio = this.datepipe.transform(this.solicitud.FechaEnvio, 'yyyy');
        const yyyy = parseInt(yearEnvio!);
        if (!yyyy) {
            return;
        }
        if (this.solicitud.TPuntoInspeccion && this.solicitud.TPuntoInspeccion.HabilitadoSanidadExterior) {
            this.alertaChedDService.checkEnvioChedD(solicitud?.Id, yyyy).subscribe(res => {
                this.envioCorreoFrChedD = res;
            });
        }
    }
}
